module.exports = __webpack_public_path__ + "static/icons/icon-onboarding1.18634f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons-mis-seguros/icon-onboarding1.svg
// module id = GqHR
// module chunks = 1